import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { min, max } from 'd3-array';
import { scaleLinear, scaleBand } from 'd3-scale';
import Chart from '../Chart/Chart.js';
import XAxis from '../Chart/XAxis.js';
import YAxis from '../Chart/YAxis.js';
import DataSeries from './DataSeries.js';
import { getWholeDollars } from '../../../utils/zhl-calculator.js';

// eslint-disable-next-line zillow/react/prefer-stateless-function
var BarChart = /*#__PURE__*/function (_Component) {
  function BarChart() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(BarChart, _Component);
  var _proto = BarChart.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      margins = _this$props.margins,
      width = _this$props.width,
      height = _this$props.height,
      legend = _this$props.legend,
      colors = _this$props.colors,
      axesColor = _this$props.axesColor,
      xAxisFormatter = _this$props.xAxisFormatter,
      tickTextStroke = _this$props.tickTextStroke;
    // eslint-disable-next-line one-var
    var values = data.map(function (item) {
        return item.value;
      }),
      labels = data.map(function (item) {
        return item.label;
      }),
      sideMargins = margins.left + margins.right,
      topBottomMargins = margins.top + margins.bottom,
      minValue = Math.min(min(values), 0),
      xScale = scaleLinear().domain([minValue, max(values)]).range([0, width - sideMargins]),
      yScale = scaleBand().domain(labels).rangeRound([margins.top, height - margins.bottom]);
    // eslint-disable-next-line one-var
    var trans = "translate(" + margins.left + "," + margins.top + ")",
      xAxisTickCount = Math.floor(width / 60);
    return /*#__PURE__*/React.createElement(Chart, {
      legend: legend,
      data: data,
      margins: margins,
      colors: colors,
      width: width,
      height: height
    }, /*#__PURE__*/React.createElement("g", {
      transform: trans,
      className: "rd3-barchart"
    }, /*#__PURE__*/React.createElement(DataSeries, {
      yScale: yScale,
      xScale: xScale,
      margins: margins,
      data: data,
      width: width - sideMargins,
      height: height - topBottomMargins
    }), /*#__PURE__*/React.createElement(YAxis, {
      yAxisClassName: "rd3-barchart-yaxis",
      yScale: yScale,
      margins: margins,
      width: width - sideMargins,
      height: height - topBottomMargins,
      tickTextStroke: tickTextStroke,
      tickStroke: axesColor,
      stroke: axesColor
    }), /*#__PURE__*/React.createElement(XAxis, {
      xAxisClassName: "rd3-barchart-xaxis",
      xScale: xScale,
      margins: margins,
      xAxisTickCount: xAxisTickCount,
      tickFormatting: xAxisFormatter,
      width: width - sideMargins,
      height: height - topBottomMargins,
      tickTextStroke: tickTextStroke,
      tickStroke: axesColor,
      stroke: axesColor
    })));
  };
  return BarChart;
}(Component);
BarChart.defaultProps = {
  margins: {
    top: 10,
    right: 20,
    bottom: 40,
    left: 50
  },
  xAxisFormatter: function xAxisFormatter(input) {
    return getWholeDollars(input);
  }
};
BarChart.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array,
  width: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  margins: PropTypes.object,
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  title: PropTypes.string,
  xAxisFormatter: PropTypes.func,
  axesColor: PropTypes.string,
  tickTextStroke: PropTypes.string,
  // Simply to satisfy eslint
  // eslint-disable-next-line zillow/react/forbid-prop-types
  legend: PropTypes.any,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  colors: PropTypes.any
} : {};

export { BarChart as default };
